// extracted by mini-css-extract-plugin
module.exports = {"Theme":"Theme_Theme__2ae8a","Theme_light":"Theme_Theme_light__2IDy7","Theme_dark":"Theme_Theme_dark__1OcgL"};